import BaseClass from "./BaseClass";
import HotelCondition from "./HotelCondition";
import GalleriesWrapper from "./media/GalleriesWrapper";
import CounterWrapper from "./counters/CounterWrapper";
import Scrollbar from "./utils/Scrollbar";
import SliderGallery from "./media/SliderGallery";
import CookiesAutomatic from "./cookies/CookiesAutomatic";
import HomeGallery from "./media/HomeGallery";
import InfoButton from "./buttons/InfoButton";
import CookiesManual from "./cookies/CookiesManual";
import MobileCarousel from "./carousel/MobileCarousel";
import Toast from "./Toast";

const defaultOptions = {};

export default class Helper extends BaseClass {

    constructor(options)
    {
        super(options, defaultOptions);

        this.init();
    }

    init()
    {
        $(document).ready(() => {
            // Initialization
            $(function () {
                $('[data-scroll-speed]').moveIt();
            });

            if ($('[data-target]').length > 0) {
                Helper.initFullscreenModals(document);
            }

            window.scrollTimer = undefined;

            window.originWidth = window.innerWidth;
            window.originHeight = window.innerHeight;

            $(window).resize(function () {
                // If both dimensions are different set them as origin. Must be both because of mobile keyboard.
                if (window.innerWidth !== window.originWidth && window.originHeight !== window.innerHeight) {
                    window.originWidth = window.innerWidth;
                    window.originHeight = window.innerHeight;
                }

                if ($('[data-title-and-date-absolute-margin-padding]').length > 0) {
                    Helper.initMarginPaddingForFeatureImage();
                }
            });

            // This component hides some content and after clicking it reveales it
            let revealerToggle = $('[data-revealer-toggle]');
            if ($(revealerToggle).length > 0) {
                $(revealerToggle).each((i, e) => {
                    let revealer = $(e).parents('[data-revealer]')
                    let content = revealer.find('[data-revealer-content]');
                    let realContent = revealer.find('[data-revealer-real-content]');

                    // if real content is smaller
                    if (realContent.height() <= content.height()) {
                        $(e).remove();

                        // make content auto height
                        $(content).css({
                            'height': 'auto'
                        })

                        // remove dim as it is not needed
                        $(revealer).find('[data-revealer-dim]').remove();

                        // dont show cursor pointer
                        $(revealer).css({
                            'cursor': 'auto'
                        })
                    }
                })

                $(revealerToggle).click(function () {
                    let revealer = $(this).parents('[data-revealer]')
                    revealer.toggleClass('active');

                    // If the component full height is supposed to be 100%
                    if (revealer.data('revealer') === 'full-height') {
                        let revealerContent = revealer.find('[data-revealer-content]');

                        if (revealer.hasClass('active')) {
                            let children = revealerContent.children();
                            let fullHeight = 0;

                            $(children).each((i, e) => {
                                fullHeight += $(e).actual('outerHeight', { includeMargin : true });
                            });

                            // one line so the shadow from revelear does not cover last line
                            fullHeight += 20;

                            revealerContent.height(fullHeight);
                        } else {
                            revealerContent.css('height', '');
                        }
                    }
                });
            }

            window.mousePos = { x: -1, y: -1 };
            $(document).mousemove(function (event) {
                window.mousePos.x = event.pageX;
                window.mousePos.y = event.pageY;
            });

            $('[data-readmore]').readmore();

            Helper.initCarouselOnlyMobile();
            Helper.initModalClosings(document);
            Helper.initModals(document);
            Helper.initTabs(document);
            Helper.initFollowablePopups(document);
            Helper.initOverflowGradients(document);
            CounterWrapper.init(document);
            Helper.initCookies();
            Helper.initHomeGallery();
            Helper.initInfoButtons();
            Helper.initCookiesManual();

            if ($('[data-title-and-date-absolute-margin-padding]').length > 0) {
                Helper.initMarginPaddingForFeatureImage();
            }

            if ($('[data-modal-to-body]').length > 0) {
                $("[data-modal-to-body]").appendTo('body');
            }

            if ($('[data-scroll-center]').length > 0) {
                $('[data-scroll-center]').click(function (e) {
                    e.preventDefault();
                    let element = $($(this).attr('href'));
                    $('html, body').animate({
                        scrollTop: element.offset().top - element.height() / 2
                    }, 1000);
                });
            }
            if ($('[data-dim-toggle]').length > 0) {
                let dimToggle = $('[data-dim-toggle]');
                dimToggle.click(function () {
                    $('[data-dim="' + dimToggle.data('dimToggle') + '"]').toggle();
                });
                $('[data-dim="' + dimToggle.data('dimToggle') + '"]').click(function () {
                    $('[data-mobile-search-open]').removeClass('nav-search--set-top');
                    dimToggle.click();
                });
            }

            let body = $('body');
            window.bodyScroll = new Scrollbar(body);
            window.bodyScroll.scrollActive = true;

            // Initialize the scrollspy, with the data attribute it should also have a id attribute
            if ($('[data-scrollspy]').length > 0) {
                let target = '#' + $('[data-scrollspy]').attr('id');
                let offset = $('[data-header-sticky]').outerHeight() + $('[data-extras]').outerHeight() + 10;
                let scrollSpy = new bootstrap.ScrollSpy(document.body, {
                    target: target
                })

                /**
                 * On window resize alter the scrollspy offset
                 */
                window.windowResizeObserve.register(function () {
                    offset = $('[data-header-sticky]').outerHeight() + $('[data-extras]').outerHeight() + 10;
                    $('body').data()['bsOffset'] = offset;
                });

                $('[data-scrollspy] a').click(function (event) {
                    event.preventDefault();
                    let marginOffset = Helper.isMobileOrLower() ? window.mobileScrollspyOffset : window.desktopScrollspyOffset;

                    if ($(this).attr('href') == '#hotel-description') {
                        offset = $('[data-header-sticky]').outerHeight() + $('[data-extras]').outerHeight();
                    } else {
                        offset = $('[data-header-sticky]').outerHeight() + $('[data-extras]').outerHeight() + marginOffset;
                    }

                    Helper.scrollToElement($($(this).attr('href')), offset * -1, 0);
                })

                // To keep first section active on scrolling all the way up
                $(window).on('scroll', function () {
                    let offsetForFirst = (Helper.isTabletOrLower())? 170 : 10;

                    if ($(this).scrollTop() <= offsetForFirst) {
                        $('[data-scrollspy]').find('a').first().addClass('active');
                    }
                });
            }

            if ($('[data-link-scroll]').length) {
                $('[data-link-scroll]').click(function (event) {
                    event.preventDefault();
                    let offset = $('[data-header-sticky]').outerHeight() + $('[data-extras]').outerHeight() + 10;

                    Helper.scrollToElement($($(this).attr('href')), offset * -1, 10);
                });
            }

            $('[data-dismiss="map-respo-masonry"]').click(() => {
                window.mapWrapper.showHideMapMasonry(null, false);
            })

            /** MASONRY GALLERY INIT ON SCROLL */
            if ($('[data-masonryscroll]').length > 0) {
                $('[data-masonryscroll]').on('scroll', () => {
                    let activePage = $('[data-set-active-page].pagination-number--active').length > 0 ? $('[data-set-active-page].pagination-number--active').data('setActivePage') : 0;
                    Helper.initSliderGallery(activePage + 1, true);
                });

                if (window.innerWidth <= 1052) {
                    document.addEventListener('scroll', () => {
                        let activePage = $('[data-set-active-page].pagination-number--active').length > 0 ? $('[data-set-active-page].pagination-number--active').data('setActivePage') : 0;
                        Helper.initSliderGallery(activePage + 1, true);
                    })
                }
            }

            if ($(".select2").length > 0) {
                $(".select2").select2({
                    minimumResultsForSearch: -1
                });
            }

            if ($(".select2-search").length > 0) {
                $(".select2-search").select2();
            }

            $('[data-stoppropagation]').on('click', (e) => {
                e.stopPropagation();
            })

            Helper.initCookieModal();

            if ($('[data-stayontop]').length > 0) {
                $(window).scrollTop(0);
            };
        });
    }

   /**
     * this function add space between thousands
     * @param {string} nStr number which we display.
     */
    static thousandsSeparator(nStr)
    {
        nStr += '';
        var x = nStr.split('.');
        var x1 = x[0];
        var x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ' ' + '$2');
        }
        return x1 + x2;
    }


    /**
     * this function adds dot between thousands
     * @param {string} nStr number which we display.
     */
    static thousandsSeparatorWithDot(nStr)
    {
        nStr += '';
        var x = nStr.split('.');
        var x1 = x[0];
        var x2 = x.length > 1 ? ',' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + '.' + '$2');
        }
        return x1 + x2;
    }

    /**
     * Translates cyrillic word to latin.
     *
     * @param {String} word cyrillic word
     *
     * @returns {String} translated word in latin
     */
    static cyrillicToLatin(word)
    {
        var a = {"Ё":"YO","Й":"I","Ц":"TS","У":"U","К":"K","Е":"E","Н":"N","Г":"G","Ш":"SH","Щ":"SCH","З":"Z","Х":"H","Ъ":"'","ё":"yo","й":"i","ц":"ts","у":"u","к":"k","е":"e","н":"n","г":"g","ш":"sh","щ":"sch","з":"z","х":"h","ъ":"'","Ф":"F","Ы":"I","В":"V","А":"a","П":"P","Р":"R","О":"O","Л":"L","Д":"D","Ж":"ZH","Э":"E","ф":"f","ы":"i","в":"v","а":"a","п":"p","р":"r","о":"o","л":"l","д":"d","ж":"zh","э":"e","Я":"Ya","Ч":"CH","С":"S","М":"M","И":"I","Т":"T","Ь":"'","Б":"B","Ю":"YU","я":"ya","ч":"ch","с":"s","м":"m","и":"i","т":"t","ь":"'","б":"b","ю":"yu"};

        return word.split('').map(function (char) {
            return a[char] || char;
        }).join("");
    }

    /**
     * Function that adds day names to datepicker
     *
     * @param {Element} datepicker selected datepicker
     *
     * @param {Boolean} setSearch true if we should reset sessions
     */
    static addDaysNameToDatepicker(datepicker, setSearch = false)
    {
        var dates = $(datepicker).tDatePicker('getDateInputs');
        if (dates[1] != null) {
            var checkIn = dates[0].split('-');
            var checkOut = dates[1].split('-');
            var checkInDay = window.weekday[new Date(checkIn[2], checkIn[1] - 1, checkIn[0]).getDay()] + ", ";
            var checkOutDay = window.weekday[new Date(checkOut[2], checkOut[1] - 1, checkOut[0]).getDay()] + ", ";
            $(datepicker).find('.t-date-check-out .t-date-info-title').text(checkOutDay);
            $(datepicker).find('.t-date-check-in .t-date-info-title').text(checkInDay);

            if (setSearch) {
                if (datepicker[0].className.includes('t-main')) {
                    window.setsearchfield(0);
                } else {
                    window.setsearchhotelfield(datepicker);
                }
            }
        }
    }

    /**
     * This function is handling loading more elements.
     *
     * @param {Element} element
     */
    loadMore(element)
    {
        element = $(element);
        let loadedTimes = parseInt(element.data('loadMoreTimes'));
        let loadLimit = parseInt(element.data('loadMoreLimit'));
        let alreadyLoadedCount = loadedTimes * loadLimit;
        let loadTo = alreadyLoadedCount + loadLimit;

        $('[data-load-more-items="' + element.data('loadMore') + '"] > *:lt(' + loadTo + ')').removeClass('hidden-mvio');
        $('[data-load-more-items="' + element.data('loadMore') + '"] > *').removeClass('last')
        $('[data-load-more-items="' + element.data('loadMore') + '"] > *:visible:last').addClass('last');

        if ($('[data-load-more-items="' + element.data('loadMore') + '"] > *:hidden').length <= 0) {
            element.parent().addClass('hidden-mvio');
        }

        element.data('loadMoreTimes', loadedTimes + 1);
    }

    /**
     * Will refresh load more items hidden/visible based on current load more state.
     *
     * @param {String} loadMoreName
     */
    refreshLoadMore(loadMoreName)
    {
        let loadMoreData = $('[data-load-more="' + loadMoreName + '"]');

        if (loadMoreData.length > 0) {
            let loadedTimes = parseInt(loadMoreData.data('loadMoreTimes'));
            let loadLimit = parseInt(loadMoreData.data('loadMoreLimit'));
            let loadedCount = loadedTimes * loadLimit;

            $('[data-load-more-items="' + loadMoreName + '"] > *:lt(' + loadedCount + ')').removeClass('hidden-mvio');
            $('[data-load-more-items="' + loadMoreName + '"] > *:gt(' + (loadedCount - 1) + ')').addClass('hidden-mvio');
            $('[data-load-more-items="' + loadMoreName + '"] > *').removeClass('last')
            $('[data-load-more-items="' + loadMoreName + '"] > *:visible:last').addClass('last');
        }
    }

    /**
     * This function initialize the simple modals.
     *
     * @param {String} parent
     */
    static initModals(parent, scroll = '[data-masonryscroll]', eventName = 'click')
    {
        // Set close modal button
        $(parent).find('[data-closemodal]').click(function (e) {
            e.preventDefault();

            var modal = $($(this).parents('[data-modal]'));
            $('[data-togglemodal="' + modal.data('modal') + '"]').parent().removeClass('active');

            if (typeof modal.data('removeactive') !== 'undefined') {
                modal.removeClass('active');
            }

            modal.hide();
        });

        $(parent).find('[data-togglemodal]').each(function () {
            if ((eventName == 'click' || $(this).data('modalEvent') == 'click') && $(this).data('modalEvent') != 'mouseover') {
                // If the event that triggers modal toggle is click then set on scroll event to keep the modal in the scrollable area
                $(scroll).on('scroll', function () {
                    $('.active > [data-togglemodal]').each(function () {
                        var modal = $($(this).attr('href'));

                        let css = {
                            'top': $(this).offset().top + $(this).outerHeight() + 5 + 'px'
                        }

                        modal.css(css);
                    });
                });
            } else if (eventName === 'mouseover' || $(this).data('modalEvent') === 'mouseover') {
                // If the event is hover, then add event on mouse out to hide the modal
                $(this).on('mouseout', function () {
                    let modal = $($(this).attr('href'));

                    modal.hide();
                    modal.removeClass('active');

                    $(this).parent().removeClass('active');
                });
            }

            if ($(this).data('modalEvent') !== undefined) {
                eventName = $(this).data('modalEvent');
            }

            // Set modal displaying on given event (click, hover, ..)
            $(this).on(eventName, function (e) {
                e.preventDefault();

                // If its our custom modal
                if ($(this).data('toggle') === '' || $(this).data('toggle') === undefined) {
                    let modal = $($(this).attr('href'));
                    let css = {};

                    if (Helper.isMobileOrLower() && modal.data('modal') !== 'sort') {
                        let padding = modal.data('modal') === 'price' && modal.data('hasdate') === 0 ? '50px 16px 16px' : '16px';

                        if (modal.data('modal') === 'facilities') {
                            padding = '16px 0';
                        }

                        $('body').css('overflow', 'hidden');

                        css = {
                            'z-index': '1003',
                            'border-radius': '0',
                            'box-shadow': 'none',
                            'max-width': 'unset',
                            'width': '100vw',
                            'height': '100%',
                            'top': '48px',
                            'padding': padding,
                            'position': 'fixed',
                            'left': '0'
                        }
                    } else {
                        if (modal.data('filterroot') !== 'facilities') {
                            css = {
                                'top': $(this).offset().top + $(this).outerHeight() + 5 + 'px',
                                'padding-top': modal.data('modal') === 'sort' ? '10px' : '20px',
                            }

                            // Decide to which side align the modal to its toggle
                            switch (modal.data('modal-direction')) {
                                case 'left': {
                                // From right to left
                                    css['left'] = $(this).offset().left + $(this).outerWidth() - modal.outerWidth() + 'px'
                                break;
                                }
                                default: {
                                    // Default is from left to right
                                    css['left'] = $(this).offset().left + 'px'
                                    }
                            }
                        } else {
                            $('body').css('overflow', 'hidden');
                            $('[data-dim="filter-modal"]').show();
                        }
                    }

                    modal.css(css);

                    if (eventName === 'mouseover') {
                        modal.show();
                        modal.addClass('active');
                        $(this).parent().addClass('active');
                    } else {
                        if (Helper.isMobileOrLower() && modal.data('modal') !== 'sort') {
                            if ($(this).data('togglemodal') !== 'all') {
                                let allOtherToggles = $('[data-filtermodalrespotoggle]');

                                allOtherToggles.each((i, e) => {
                                    $(e).parent().removeClass('active');
                                    let modalToHide = $($(e).attr('href'));
                                    modalToHide.hide();
                                })
                            }

                            modal.show();
                            modal.addClass('active');
                            $(this).parent().addClass('active');
                        } else {
                            modal.toggle();
                            modal.toggleClass('active');
                            $(this).parent().toggleClass('active');
                        }
                    }

                    // Specific to modals for filters (it clears the selected checkboxes that were not saved)
                    if ($('[data-filterroot="' + $(this).data('togglemodal') + '"]').length > 0 && !modal.hasClass('active')) {
                        window.masonryFilter.clearNotSelectCheckboxes($('[data-filterroot="' + $(this).data('togglemodal') + '"]'));
                    }
                }
            });
        });
    }

    /**
     * Checks if the element is in given view.
     *
     * @param {Element} element
     * @param {boolean} fullyInView
     * @param {Element} view
     */
    static isElementInView(element, fullyInView, view = window)
    {
        let pageTop = $(view).scrollTop();
        let pageBottom = pageTop + $(view)[0].innerHeight;
        let elementTop = $(element).offset().top;
        let elementBottom = elementTop + $(element).height();

        if (fullyInView) {
            return ((pageTop < elementTop) && (pageBottom > elementBottom));
        } else {
            return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
        }
    }

    /**
     * This function will scroll window element to a top of given element.
     *
     * @param {Element} destination
     * @param {Number} offsetTop
     * @param {Number} speed
     */
    static scrollToElement(destination, offsetTop = 0, speed = 1000)
    {
        $([document.documentElement, document.body]).animate({
            scrollTop: $(destination).offset().top + offsetTop
        }, speed);
    }

    /**
     * This function initialize tabs components under parent.
     *
     * @param {String} parent
     */
    static initTabs(parent)
    {
        if ($(parent).find('[data-tabs-toggles]').length > 0) {
            $(parent).find('[data-tabs-toggles] > a').click(function (e) {
                e.preventDefault();
                $(this).parent().find('a').each(function () {
                    $(this).removeClass('active');
                    $('[data-tabs-content="' + $(this).data('target') + '"]').addClass('hidden-mvio');
                    $('[data-tabs-content="' + $(this).data('target') + '"]').removeClass('active');
                });

                $(this).addClass('active');
                $('[data-tabs-content="' + $(this).data('target') + '"]').removeClass('hidden-mvio');
                $('[data-tabs-content="' + $(this).data('target') + '"]').addClass('active');
            });
        }
    }

    /**
     * This function initialize followable popups under given parent.
     *
     * @param {String|Element} parent
     */
    static initFollowablePopups(parent)
    {
        let xOffset = 20;

        $(parent).find('[data-followable-popup]').each(function () {
            $(this).on('click', (e) => {
                let marginOffset = Helper.isMobileOrLower() ? window.mobileScrollspyOffset : window.desktopScrollspyOffset;
                let offset = $('[data-header-sticky]').outerHeight() + $('[data-extras]').outerHeight() + marginOffset;
                window.scrollToElement($('#hotel-rooms'), -1 * offset);

                if ($(this).data('opensecondarycalendar') !== undefined) {
                    let datepicker = $('[data-search="rooms"] [data-datepicker-start]');

                    if ($(datepicker).length > 0) {
                        $(datepicker).click();
                    }
                }
            })

            $(this).followPopup({
                x: xOffset,
                y: 20,
                html: $('[data-popup="' + $(this).data('followablePopup') + '"]').html(),
                afterEnter: (trigger) => {
                    let popup = $('.js-followPopup').first();

                    if (($(this).attr('data-hide-popup') !== undefined)) {
                       popup.css('display', 'none');
                       return;
                    }

                    // The plugin has timeout of 40 on positioning
                    setTimeout(() => {
                        let windowTop = $(window).scrollTop();
                        let windowCenter = $(window).width() / 2;
                        let popupPositions = popup.css('inset').split(' ');
                        let headerHeight = $('header').outerHeight();
                        let headerExtrasHeight = $('.header-extras--wrapper').outerHeight();

                        if (Helper.isLaptopOrHigher()) {
                            // If true, the popup has overflown the window
                            if (windowTop > popup.offset().top - headerHeight - headerExtrasHeight) {
                                let bottom = (parseFloat(popupPositions[2]) - (parseFloat(popup.outerHeight()) / 2)) + 'px';
                                popup.css('bottom', bottom);
                            }

                            // If true, the mouse x position is on the right side of a page
                            if (window.mousePos.x > windowCenter) {
                                let right = window.outerWidth - window.mousePos.x;
                                popup.css('left', 'auto');
                                popup.css('right', right + 'px');
                            }
                        } else {
                            if (Helper.isMobileOrLower()) {
                                Helper.setPopupMobile(popup);
                            } else {
                                Helper.setPopupTablet(popup);
                            }
                        }
                    }, 40);
                },
                onMove: () => {
                    setTimeout(() => {
                        let popup = $('.js-followPopup').first();

                        if (($(this).attr('data-hide-popup') !== undefined)) {
                            popup.css('display', 'none');
                            return;
                        }

                        if (Helper.isTabletOrLower()) {
                            if (Helper.isMobileOrLower()) {
                                Helper.setPopupMobile(popup);
                            } else {
                                Helper.setPopupTablet(popup);
                            }

                            if (!$(this).hasClass('disable-scroll')) {
                                if ($(popup).find('[data-showpricemodal]').length === 0 && $(popup).find('[data-noscroll]').length === 0) {
                                    Helper.scrollToElement(popup, -200, 500);
                                }
                            }
                        } else {
                            let popup = $('.js-followPopup').first();
                            let windowTop = $(window).scrollTop();
                            let windowCenter = $(window).width() / 2;
                            let popupPositions = popup.css('inset').split(' ');
                            let headerHeight = $('header').outerHeight();
                            let headerExtrasHeight = $('.header-extras--wrapper').outerHeight();

                            if (windowTop > popup.offset().top - headerHeight - headerExtrasHeight) {
                                let bottom = (parseFloat(popupPositions[2]) - (parseFloat(popup.outerHeight()) / 2)) + 'px';
                                popup.css('bottom', bottom);
                            }

                            // If true, the mouse x position is on the right side of a page
                            if (window.mousePos.x > windowCenter) {
                                let right = window.outerWidth - window.mousePos.x;
                                popup.css('left', 'auto');
                                popup.css('right', right + 'px');
                            }
                        }
                    }, 40);
                },
            });
        });
    }

  /**
   * Init custom fullscreen modals
   *
   * @param {Element} parent - document
   */
    static initFullscreenModals(parent)
    {
        // just room modals - so the other wont be initialized twice
        $(parent).find('[data-target^="#room_detail_"]').each((i, e) =>  {

            let modalName = $(e).data('target');
            let modal = $(modalName);

            $('[data-target="'+modalName+'"]').click((event) => {
                let showOnTablet = $(event.target).data('donttoggleontablet');

                if (showOnTablet === 1) {
                    if (Helper.isTabletOrLower()) {
                        modal.modal('show');
                    }
                } else {
                    modal.modal('show');
                }
            })
        });
    }

    /**
     * This function initialise room dependencies (modals, ..).
     *
     * @param {String} parent
     * @param {Object} data
     */
    static initRoomsDependencies(parent, data)
    {
        GalleriesWrapper.init(parent);
        Helper.initFollowablePopups(parent);
        Helper.initModalClosings(parent);
        $('[data-toggle="tooltip"]').tooltip();

        $('body > [data-modal-to-body]:not([data-modal-to-body="keep"])').remove();
        $(parent).find('[data-modal-to-body]').appendTo('body');
        Helper.initModals(parent, '[data-rooms-scroll]', 'mouseover');

        // Updates the free conditions shown beside hotel gallery
        HotelCondition.rewriteFreeConditions('[data-conditions-wrapper]', data.freeConditions);
    }

    /**
     * This function initialise treatments dependencies (counters, ..).
     *
     * @param {String|Element} parent
     */
     static initTreatmentsDependencies(parent)
     {
        Helper.initTabs(parent);
        CounterWrapper.init(parent);
        Helper.initModalClosings(parent);
        Helper.initOverflowGradients(parent);
     }

    /**
     * This function will return price with currency in right format.
     *
     * @param {*} price
     *
     * @returns {String} format "currency price"
     */
     static formatPrice(price)
     {
         if (typeof price === 'string' || price instanceof String) {
             price = price.replace(',', '.').replace(' ', '');
         }
         price = '' + parseFloat(price).toFixed(2);
         price = price.replace(/(.)(?=(.{3})+$)/g,"$1 ");
         let currencySymbol = $('[name="currency_symbol"]').val();

         let priceString = price + ' ' + currencySymbol;
         return priceString.replace('.', ',').replace(' ,', ',');
     }

    /**
     * This function will trigger active class on all activeable parents.
     *
     * @param {Element} trigger
     */
     toggleActiveParents(trigger)
     {
         $(trigger).parents('[data-activable]').toggleClass('active').find('[data-activable-additional]').click();
     }

    /**
     * Will parse JSON object from given string. If its unparseable, it will return empty Object.
     *
     * @param {String|Object} jsonString
     * @returns {Object}
     */
     static parseJSON(jsonString)
     {
         if (typeof jsonString === 'object' && jsonString !== null) {
             return jsonString;
         }

         let json = {};

        // If JSON string is set
         if (jsonString) {
            // If is not valid JSON string
             if (! (/^[\],:{}\s]*$/.test(jsonString.replace(/\\["\\\/bfnrtu]/g, '@').
              replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').
              replace(/(?:^|:|,)(?:\s*\[)+/g, '')))) {
                 jsonString = JSON.stringify(jsonString);
             }

             json = JSON.parse(jsonString);
         }

         return json;
     }

    /**
     * This function will capitalize first letter in given string.
     *
     * @param {String} string
     *
     * @returns {String}
     */
     static capitalize(string)
     {
         return string.charAt(0).toUpperCase() + string.slice(1);
     }

    /**
     * This function will copy value from input under the trigger element and will copy it to clipboard.
     *
     * @param {Element} trigger
     */
     copyToClipboard(trigger)
     {
        let copyInput = $(trigger).find('>input').first()[0];

        copyInput.select();
        copyInput.setSelectionRange(0, 99999); /* For mobile devices */

        document.execCommand("copy");
        new Toast('clipboard-toast');
     }

    /**
     * This function will intialize bootstrap modals clicking aways closing.
     *
     * @param {Element|String} parent
     */
     static initModalClosings(parent)
     {
         if ($(parent).find('.modal-dialog').length > 0) {
             // Keep closing modals on clicking next to content
             $(parent).find('.modal-dialog').on('click tap', function (e) {
                if ($(e.target).hasClass('modal-dialog')) {
                      $('.modal.in').modal('hide');
                }
             });
         }
     }

    /**
     * This function intialize ovrflowing gradinet overflown marking.
     *
     * @param {Element|String} parent
     */
     static initOverflowGradients(parent)
     {
         if ($(parent).find('.overflow-gradient').length > 0) {
             $(parent).find('.overflow-gradient').each(function () {
                if ($(this).hasScrollBar(445)) {
                      $(this).addClass('overflown');
                }

                $(window).resize(() => {
                    if ($(this).hasScrollBar(445)) {
                        $(this).addClass('overflown');
                    } else {
                        $(this).removeClass('overflown');
                    }
                })
             });
         }
     }

    /**
     * This function will initialize on window scroll slide up/down functionality of given elements.
     *
     * @param {Element} element
     * @param {Number} breakpoint
     * @param {Number} baseMinHeight base min-height, default is 126 (header nav min-height)
     */
     initScrollSlide(element, breakpoint, baseMinHeight = 126)
     {
         let $element = $(element);

         $(window).on('scroll', function () {
            // If body can be scrolled
            if ($(this).width() <= breakpoint && $('body').css('overflow-y') !== 'hidden') {
                if ($(window).scrollTop() > 0) {
                    if (window.scrollTimer) {
                        clearTimeout(window.scrollTimer);
                    }

                    let newMinHeight = baseMinHeight - $(window).scrollTop();
                    if (newMinHeight >= 0) {
                        $element.css('min-height', newMinHeight + 'px');
                    }

                    // When triggered that means that the user stopped scrolling
                    window.scrollTimer = setTimeout(function () {
                        let elementMinHeight = parseInt($element.css('min-height').split('px')[0]);

                        if (elementMinHeight !== 0 && $(window).scrollTop() <= baseMinHeight) {
                            $element.css('min-height', '');
                        }
                    }, 150);
                }
            }
         });
     }


    /**
     * Determine the mobile operating system.
     * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
     *
     * @returns {String}
     */
     static getMobileOperatingSystem()
     {
         let userAgent = navigator.userAgent || navigator.vendor || window.opera;

         // Windows Phone must come first because its UA also contains "Android"
         if (/windows phone/i.test(userAgent)) {
              return "winphone";
         }

         if (/android/i.test(userAgent)) {
             return "android";
         }

         // iOS detection from: http://stackoverflow.com/a/9039885/177710
         if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
             return "ios";
         }

         return "";
     }

    /**
     * Checks if the operations system belongs to mobile ones.
     *
     * @returns {Boolean}
     */
     static isMobileOS()
     {
         return ['winphone', 'android', 'ios'].includes(Helper.getMobileOperatingSystem());
     }

    /**
     * Checks if the mobile operating system is IOS
     *
     * @returns {Boolean}
     */
     static isIOS()
     {
         return Helper.getMobileOperatingSystem() === 'ios';
     }

    /**
     * Checks if the mobile operating system is Android
     *
     * @returns {Boolean}
     */
    static isAndroid()
    {
        return Helper.getMobileOperatingSystem() === 'android';
    }

    /**
     * Checks if the mobile keyboard is active.
     *
     * @returns {boolean}
     */
     static isMobileKeyboardActive()
     {
         return (
         (window.innerHeight < window.originHeight)
         &&
         ['winphone', 'android', 'ios'].includes(Helper.getMobileOperatingSystem())
         );
     }

    /**
     * Returns Mobile keyboard height.
     * ! Should be called after isMobileKeyboardActive() check
     *
     * @returns {Number}
     */
     static getMobileKeyboardHeight()
     {
         return window.originHeight - window.innerHeight;
     }

    /**
     * Returns true if header fits whole to window.
     * * Header overflow detection on the landscape orientation in mobile.
     *
     * @returns {Boolean}
     */
     static headerFitsTheWindow()
     {
         return $('#header').outerHeight() <= window.innerHeight;
     }

    /**
     * Checks if the mobile is landscape oriented.
     *
     * @returns {Boolean}
     */
     static isMobileLandscapeOriented()
     {
         return Helper.isBigMobileOrLower() && window.innerHeight < window.innerWidth;
     }

     /**
     * Checks if current window is under laptop breakpoint.
     *
     * @returns {boolean}
     */
      static isLaptopOrHigher()
      {
         return $(window).width() > window.tabletBreakpoint;
      }

     /**
      * Checks if current window is under laptop breakpoint.
      *
      * @returns {boolean}
      */
      static isLaptopOrLower()
      {
          return $(window).width() <= window.laptopBreakpoint;
      }

      /**
      * Checks if current window is under tablet breakpoint.
      *
      * @returns {boolean}
      */
      static isTabletOrLower()
      {
          return $(window).width() <= window.tabletBreakpoint;
      }

      /**
      * Checks if current window is bigger than big mobile breakpoint.
      *
      * @returns {Boolean}
      */
      static isTabletOrHigher()
      {
          return $(window).width() > window.bigMobileBreakpoint;
      }

      /**
      * Checks if current window is under big mobile breakpoint.
      *
      * @returns {boolean}
      */
      static isBigMobileOrLower()
      {
          return $(window).width() <= window.bigMobileBreakpoint;
      }

      /**
      * Checks if current window is under mobile breakpoint.
      *
      * @returns {boolean}
      */
      static isMobileOrLower()
      {
          return $(window).width() <= window.mobileBreakpoint;
      }

     /**
      * Function that check is email is in correct format
      *
      * @param {String} email
      * @returns {boolean}
      */
      static checkEmailCorrectness(email)
      {
          let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

          return regex.test(email);
      }

    /**
    * Function that sets mobile pop up css
    *
    * @param {Element} popup
    */
      static setPopupMobile(popup)
      {
          popup.css('position', 'absolute');
          popup.css('z-index', '997');
          popup.css('display', 'block');
          popup.css('left', '16px');
          popup.css('top', 'unset');
          popup.css('bottom', $('body')[0].offsetHeight - window.mousePos.y + 'px');
          popup.css('right', '16px');
      }

    /**
    * Function that sets tablet pop up css
    *
    * @param {Element} popup
    */
    static setPopupTablet(popup)
    {
        popup.css('position', 'absolute');
        popup.css('z-index', '997');
        popup.css('display', 'block');
        popup.css('top', 'unset');
        popup.css('bottom', $('body').actual('outerHeight', { includeMargin : true }) - ($(popup).height() / 2) - window.mousePos.y + 'px');
        popup.css('left', $(window).width() / 2 - $(popup).width() / 2);
    }

    /**
    * Function that tells if element is in viewport
    *
    * @param {Element} e
    * @returns {boolean}
    */
      static isInViewport(e)
      {
          const rect = e.getBoundingClientRect();
          const elementHeight = e.offsetHeight;
          const elementWidth = e.offsetWidth;

          return rect.top >= -elementHeight
          && rect.left >= -elementWidth
          && rect.right <= (window.innerWidth || document.documentElement.clientWidth) + elementWidth
          && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) + elementHeight;
      }

    /**
    * Function that clears input
    *
    * @param {String} inputName name of the input we want to clear
    */
      clearInput(inputName)
      {
          let input = $('input[name="'+inputName+'"]');
          if (input.val() !== '') {
              input.val('');
              input.keyup();
              let searchRoot = $('[data-filterroot="' + $(input).data('filtersearch') + '"]');

              // Toggle all more options blocks to not visible
              searchRoot.find('[data-togglemoreoptions].active').trigger('click');
          }
      }

  /**
   * Function that handles "double" filter modal on mobile
   *
   * @param {Boolean} show
   */
      showFilterModalRespo(show)
      {
          if (Helper.isMobileOrLower()) {
              if (show) {
                  $('[data-filtermodalrespo]').show();
                  $('[data-filtermainlist]').css('display', 'flex')
                  $('[data-togglemodal="ratings"]').click();
                  $('body').css({
                    'position': 'fixed'
                  })
              } else {
                  $('[data-filtermodalrespo]').hide();
                  $('[data-filtermainlist]').css('display', 'none');
                  $('[data-modal].active').hide();

                  $('body').css({
                    'position': 'relative',
                  })
              }
          }
      }

    /**
    * Function that inits slider gallery
    * It is called from pagination, because gallery is always initialized only when page is active
    *
    * @param {Number} pageNumber current page number
    * @param {Boolean} fromScroll indicates if the function is called from scroll event
    */
      static initSliderGallery(pageNumber, fromScroll = false)
      {
          let positions = pageNumber * 20;
          $(document).find('[data-sortable]').each((i, e) => {

                if ($(e).data('entityPosition') < positions) {
                    let galleryElement = $(e).find('[data-slider-gallery]');

                    if ($(galleryElement).length > 0) {
                        if (Helper.isElementInView(galleryElement, false)) {
                            let name = $(galleryElement).data('sliderGallery');

                            if (!fromScroll) {
                                if (window.galleries[name] !== undefined) {
                                    if (window.galleries[name].slider !== undefined) {
                                        window.galleries[name].slider.destroy(true);
                                    }
                                    delete window.galleries[name];
                                }

                                let gallery = new SliderGallery(name);

                                window.galleries[name] = gallery;
                                gallery.initGallery();
                            } else {
                                if (window.galleries[name] === undefined) {
                                    let gallery = new SliderGallery(name);

                                    window.galleries[name] = gallery;
                                    gallery.initGallery();
                                }
                            }
                        }
                    }
                }
              });
      }

    /**
    * Function that redirects to url
    *
    * @param {String} url url
    * @param {Boolean} onDesktopAndMobile redirect works on desktop and mobile, if false only mobile
     * @param {Boolean} blank if true open in new tab
    */
      redirectTo(url, onDesktopAndMobile, blank = true)
      {
          if (onDesktopAndMobile) {
              if (blank) {
                  window.open(url, '_blank').focus();
              } else {
                  window.open(url, '_self').focus();
              }
          } else {
              if (Helper.isTabletOrLower()) {
                  if (blank) {
                      window.open(url, '_blank').focus();
                  } else {
                      window.open(url, '_self').focus();
                  }
              }
          }
      }

  /**
   * Hand popup height image
   */
    static handleMapPopupImage()
    {
        let popups = $('[data-mappopup]');

        $(popups).each((i, e) => {
            let height = $(e).height();

            $(e).find('[data-popupimagemobile]').css({
                'height': height + 'px'
            })
        })
    }

    /**
     * Init cookies class
     */
      static initCookies()
      {
          new CookiesAutomatic()
      }

    /**
     * Function that inits and counts on resize margins and paddings of container on landing pages so feature image
     * which is positioned absolutely can have text inside which is correctly placed
     */
      static initMarginPaddingForFeatureImage()
      {
        let source = $('[data-title-and-date-absolute-margin-padding]');
        let destination = $('[data-title-and-date-absolute]');

        // get margins + paddings from wrapper and / 2 because it counts both sides
        let left = (($(source).outerWidth(true) - $(source).outerWidth()) + ($(source).innerWidth() - $(source).width())) / 2;

        if ($(destination).data('titleAndDateAbsolute') === 'no-mobile') {
            if (!Helper.isMobileOrLower()) {
                $(destination).css({
                    'left': left + 'px'
                })
            } else {
                $(destination).css({
                    'left': 0
                })
            }
        } else if ($(destination).data('titleAndDateAbsolute') === 'no-tablet') {
            // map breakpoint is 1052 - thats when graphic changes to "tablet"
            if ($(window).width() <= window.mapBreakpoint) {
                $(destination).css({
                    'left': 0
                })
            } else {
                $(destination).css({
                    'left': left + 'px'
                })
              }
        } else {
            $(destination).css({
                'left' : left + 'px'
            })
        }
      }

    /**
     * Function that inits home gallery
     */
      static initHomeGallery()
      {
          if ($('[data-home-gallery]').length > 0) {
              let gallery = new HomeGallery('home');
              window.galleries[name] = gallery;
              gallery.initGallery();
          }
      }

    /**
     * Function that inits info buttons
     */
      static initInfoButtons()
      {
          if ($('[data-info-button]').length > 0) {
              $('[data-info-button]').each((i, e) => {
                    new InfoButton($(e).data('infoButton'));
                });
          }
      }

    /**
     * Function that hides panel (a.k.a. module/div)
     * @param {Element} e clicked element
     */
      hidePanel(e)
      {
          let hidePanel = $(e).data("hidepanel");
          $("[data-hide='" + hidePanel + "']").remove();
      }

    /**
     * Inits cookies that are set manually by user (clicking on button)
     */
      static initCookiesManual()
      {
          $('[data-cookiesManual]').each((i, e) => {
                new CookiesManual($(e).data('cookiesmanual'));
            })
      }

    /**
     * Init carousel only on mobile
     */
      static initCarouselOnlyMobile()
      {
          if ($('[data-carouselonlymobile]').length > 0) {
              $('[data-carouselonlymobile]').each((i, e) => {
                    new MobileCarousel($(e)[0].id);
                });
          }
      }

    /**
    * Sets homepage body height
    *
    * @param {boolean} countBodyHeight
    */
    static setBodyHeight(countBodyHeight = false)
    {
        if ($('[data-bodyheight]').length > 0 && !Helper.isMobileOrLower()) {
            let height = 0;

            $('[data-bodyheight]').each((i, e)  => {
                height += $(e).actual('outerHeight');
            })

            $('body').css({
                'height': height + 'px'
            });


            return height;
        }

        if (countBodyHeight) {
            return $('body').actual('outerHeight');
        }

        return window.innerHeight;
    }

    /**
     * Function that inits setting for cookie modal
     */
    static initCookieModal() {
        $('#cookie_settings').on('hide.bs.modal', (e) => {
           window.htmlOverflowY('unset');
        })

        $('#cookie_settings').on('show.bs.modal', (e) => {
            window.htmlOverflowY('hidden');
        })
    }

    /**
     * Function set overflow-y value
     *
     * @param {String} value
     */
    htmlOverflowY(value) {
        $('html').css('overflow-y', value);
    }

    /**
     * Function that checks filesize of profile picture of user
     *
     * @param {Element} input
     *
     * @returns
     */
    proccessPhoto(input) {
        let file = input.files[0];
        let filesize = ((file.size / 1024)).toFixed(4); // in KB

        // If a photo's filesize is more than 300 KB
        if (filesize > 300) {
            let errorElement = $('[data-uploads-error="big-files"]');
            let errorMessage = errorElement.data('errorStart') + ' ';
            errorMessage += file.name + ' - ' + filesize + ' KB';
            errorElement.find('p').html(errorMessage);
            errorElement.show();
            $(input).val('');
            $('[data-photolabel]').html($('[data-photolabeldefaultvalue]').html());
            $('p[data-hideblock="show-picture"]').click();
            $('[data-savephoto]').prop('disabled', true);
            return;
        } else {
            $('[data-savephoto]').prop('disabled', false);
        }
    }

    static htmlEntityDecode(str) {
        var temp = document.createElement('div');
        temp.innerHTML = str;
        return temp.textContent || temp.innerText;
    }
}
